import { useSelector } from 'react-redux'
import '../styles/components/SloganStyle.scss'
import Markdown from './Markdown';

const Slogan = () => {
  const headerContent = useSelector((state) => state.cms?.navbar)
  return (
    <div className="d-flex flex-column mt-3 mb-4 align-items-start text-start slogan-wrapper">
      <div className="slogan d-flex align-items-center bg-primary text-white">
        <i className="material-icons me-2">emoji_events</i>
        <span className="slogan-text">
          <Markdown>{headerContent?.title}</Markdown>
        </span>
      </div>
    </div>
  )
}

export default Slogan
